export const DEFAULT_RESULT = '';
